export default __webpack_public_path__ + "static/360_image-4547d04bd1d5368f881215b54c12062b.png";